import { z } from 'zod';

export enum PCSAlgorithm {
  PCS_EFFICIENCY = 'PCS Efficiency',
  POWER_CAPABILITY = 'Power Capability',
  POWER_AVAILABILITY = 'Power Availability',
}

export const PCSAlgorithmSchema = z.nativeEnum(PCSAlgorithm);
